import * as Normalize from '../normalize';
import * as Types from './types';

export const normalize = Normalize.normFn<Types.PanelSettingsObjSchema>(
  'panelSettings',
  whole => whole
);

export const denormalize = Normalize.denormFn<Types.PanelSettingsObjSchema>(
  part => part
);
